import {PropsWithChildren, ReactNode} from "react";

export default function Field({
    label,
    children,
    error,
    required,
    className=''
                              }:{
    label: ReactNode,
    error?: ReactNode,
    required?: boolean
    className?: string

}&PropsWithChildren){
    return <div className={`matchid-field-box ${className}`}>
        <div className="matchid-field-label">{required&&<span className={"matchid-field-required"}>*</span>}{label}</div>
        {children}
        {error && <div className="matchid-field-error">{error}</div>}
    </div>

}